import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import StyledMaterialIcon from './styles';
import warning from '../utils/console-deprecated';

// Any numbers passed here will be multiplied by 1.5rem.
const sizeMap = {
  small: 0.8,
  medium: 1.4,
  large: 2
};
const Icon = ({
  type,
  color,
  size = 'medium',
  align,
  className,
  icon = '',
  ...props
}) => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(StyledMaterialIcon, _extends({
    className: className,
    path: icon,
    "data-align": align,
    color: theme.palette[color] || color,
    size: Number.isFinite(size) ? size : sizeMap[size] || size
  }, props));
};

/* istanbul ignore next */
export const IconTypePropValidator = (props, propName) => {
  if (!props[propName] && !props.icon) {
    warning(`Icon / The prop \`${propName}\` is required if the \`icon\` prop is not set`);
  }
  return undefined;
};
Icon.propTypes = {
  type: IconTypePropValidator,
  color: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  align: PropTypes.string,
  icon: PropTypes.string
};
export default Icon;
//# sourceMappingURL=index.js.map